import React from "react";
import { useTranslation } from "react-i18next";
import { useRamadan } from "../context/RamadanContext";

const SalatTracker: React.FC = () => {
  const { t } = useTranslation();
  const { dayData, updateSalat } = useRamadan();

  const handleCheckboxChange = (
    name: string,
    type: "farad" | "sunnah" | "nafal",
    checked: boolean
  ) => {
    updateSalat(name, type, checked);
  };

  // If dayData is not loaded yet
  if (!dayData) {
    return <div className="animate-pulse">Loading...</div>;
  }

  return (
    <div className="bg-[#f7f5e8] border border-[#eae3c9] rounded-lg p-0">
      {/* Title with icon */}
      <div className="flex items-center justify-center py-2 space-x-2">
        <div className="bg-[#e8dab8] rounded-lg w-10 h-10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-[#8a744e]"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z" />
          </svg>
        </div>
        <h2 className="text-lg font-bengali font-semibold text-[#8a744e]">
          {t("sections.salatTracker")}
        </h2>
      </div>

      {/* Prayer table with column headers */}
      <div className="pt-1 pb-2">
        {/* Header row with titles - using the same grid format as content below */}
        <div className="grid grid-cols-3 mb-2 px-2">
          <div className="text-center text-sm font-bengali text-[#8a744e]"></div>
          <div className="text-center text-sm font-bengali text-[#8a744e]">
            {t("salat.farad")}
          </div>
          <div className="text-center text-sm font-bengali text-[#8a744e]">
            {t("salat.sunnah")}
          </div>
        </div>

        {/* Prayer rows */}
        <div className="space-y-0">
          {dayData.salats.map((salat, index) => (
            <div key={index} className="grid grid-cols-3 items-center border-t">
              <div className="font-bengali text-center py-1 text-[#8a744e]">
                {salat.name}
              </div>

              <div className="flex justify-center py-1">
                {[
                  t("salats.fajr"),
                  t("salats.zuhr"),
                  t("salats.asr"),
                  t("salats.maghrib"),
                  t("salats.isha"),
                ].includes(salat.name) && (
                  <div
                    className="w-5 h-5 border border-[#c9bc94] bg-white flex items-center justify-center cursor-pointer"
                    onClick={() =>
                      handleCheckboxChange(salat.name, "farad", !salat.farad)
                    }
                  >
                    {salat.farad && (
                      <div className="w-3 h-3 bg-[#8a744e]"></div>
                    )}
                  </div>
                )}
              </div>

              <div className="flex justify-center py-1">
                <div
                  className="w-5 h-5 border border-[#c9bc94] bg-white flex items-center justify-center cursor-pointer"
                  onClick={() =>
                    handleCheckboxChange(salat.name, "sunnah", !salat.sunnah)
                  }
                >
                  {salat.sunnah && <div className="w-3 h-3 bg-[#8a744e]"></div>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SalatTracker;
